import {HiMiniSpeakerWave} from "react-icons/hi2";
import {GoDotFill} from "react-icons/go";
import {FaEyeSlash} from "react-icons/fa";
import {motion} from "framer-motion";
import {AiFillHeart, AiOutlineHeart} from "react-icons/ai";


export default function VocabInfo({className, data, mask, isFavorited, toggleFav, ...props}) {
    const dict = data?.dict;

    function playAudio() {
        let audio = new Audio(dict?.audioUrl);
        audio.play();

    }

    return (
        <div className={` ${className}`}>

            <div className={"border-t-[1px] p-2 pb-8 flex flex-col gap-4"}>

                <div className={" flex"}>
                    {
                        mask?.word ? <p className={"text-secondary-900 font-semibold"}>{dict?.word}
                            <span>
                        <HiMiniSpeakerWave
                            onClick={playAudio}
                            className={"inline-block text-base cursor-pointer ml-2 text-secondary-900"}/>
                    </span>
                        </p> : <p
                            className={"text-secondary-900 "}><FaEyeSlash className={"inline-flex mr-2"}/>Word</p>
                    }

                    <div className={"ml-auto"} onClick={()=>{
                        if (toggleFav) toggleFav(data?.id)
                    }}>
                        {

                            isFavorited ? <AiFillHeart className={" text-secondary-900 cursor-pointer"}/> :
                                <AiOutlineHeart className={"ml-auto text-secondary-900 cursor-pointer"}/>
                        }
                    </div>

                </div>

                {/*<p className={"text-black text-sm"}>*/}
                {/*    {dict?.phonetic}*/}
                {/*    <span>*/}
                {/*        <HiMiniSpeakerWave*/}
                {/*            onClick={playAudio}*/}
                {/*            className={"inline-block text-base cursor-pointer ml-2 text-secondary-900"}/>*/}
                {/*    </span>*/}
                {/*</p>*/}
                <div className={"flex flex-row"}>
                    <p className={"rounded-full border-secondary-900 text-secondary-900 text-xxs px-3  border-[1px]"}>
                        CER-{data?.cefr}
                    </p>
                </div>

                {
                    mask?.definition ? dict?.definitions?.map((definition, index) => {
                        return (
                            <motion.div
                                initial={{height: 0, opacity: 0,}}
                                animate={{height: "auto", opacity: 1}}
                                transition={{duration: 0.5}}


                                key={index} className={"flex flex-col gap-2"}>
                                <p className={"font-bold"}>
                                    {
                                        definition?.partOfSpeech || definition?.tense
                                    }
                                </p>
                                <p className={"text-sm text-gray-400 lowercase"}>
                                    {
                                        definition?.tense || definition?.partOfSpeech
                                    }
                                </p>
                                <div>
                                    <div className={"flex flex-col gap-2"}>
                                        {
                                            definition?.definition?.map((item, index) => {
                                                return (
                                                    <div key={index}
                                                         className={"text-sm flex gap-2 justify-center  flex-row  text-gray-800"}>
                                                        <div className={"mt-1.5"}>
                                                            <GoDotFill/>
                                                        </div>
                                                        <div className={"flex flex-col flex-1"}>
                                                            <p className={"inline-flex"}>
                                                                {item?.explanation}
                                                            </p>
                                                            {
                                                                (item?.example && mask?.example) && <p className={""}>
                                                                    {item?.example}
                                                                </p>
                                                            }
                                                            {(item?.synonyms?.length > 0 && mask?.synonyms) && <div
                                                                className={"rounded-md bg-gray-100 p-2 mt-2 flex flex-col"}>
                                                                <p className={"font-bold text-sm"}>
                                                                    Synonyms
                                                                </p>
                                                                <div
                                                                    className={"flex flex-row flex-wrap px-2 mt-2 gap-2"}>
                                                                    {
                                                                        item?.synonyms?.map((synonym, index) => {
                                                                            return (
                                                                                <p key={index}
                                                                                   className={"border-[1px] rounded-full px-4 bg-gray-200 text-xs"}>
                                                                                    {synonym}
                                                                                </p>
                                                                            )
                                                                        })
                                                                    }


                                                                </div>
                                                            </div>}
                                                        </div>
                                                    </div>
                                                )
                                            })
                                        }
                                    </div>
                                </div>


                            </motion.div>
                        )
                    }) : <div className={"text-secondary-900 flex flex-row gap-2 justify-center items-start "}>
                        <FaEyeSlash className={"my-auto"}/>
                        <p className={"font-bold"}>
                            Definition
                        </p>
                    </div>

                }


            </div>
        </div>

    )
}